import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * MessageFormatter - Renders markdown-formatted text in chat messages
 * 
 * Supports:
 * - **bold** and *italic* text
 * - Lists and bullet points
 * - Links and basic formatting
 * - GitHub Flavored Markdown extensions
 */
const MessageFormatter = ({ content, ...props }) => {
  // Handle empty or null content
  if (!content || typeof content !== 'string') {
    return <span {...props}>{content}</span>;
  }

  // MessageFormatter handles markdown content for all agents

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // Customize paragraph styling to preserve line breaks
        p: ({node, ...props}) => <div style={{margin: '0.5em 0'}} {...props} />,
        // Handle line breaks
        br: ({node, ...props}) => <br {...props} />,
        // Customize list styling with better spacing
        ul: ({node, ...props}) => <ul style={{margin: '1em 0', paddingLeft: '1.2em', marginBottom: '1.5em'}} {...props} />,
        ol: ({node, ...props}) => <ol style={{margin: '1em 0', paddingLeft: '1.2em', marginBottom: '1.5em'}} {...props} />,
        li: ({node, ...props}) => <li style={{margin: '0.4em 0', lineHeight: '1.6'}} {...props} />,
        // Customize emphasis styling
        strong: ({node, ...props}) => <strong style={{fontWeight: 600}} {...props} />,
        em: ({node, ...props}) => <em style={{fontStyle: 'italic'}} {...props} />,
        // Render actual header elements for proper CSS styling
        h1: ({node, ...props}) => <h1 style={{margin: '1.2em 0 0.5em'}} {...props} />,
        h2: ({node, ...props}) => <h2 style={{margin: '1em 0 0.5em'}} {...props} />,
        h3: ({node, ...props}) => <h3 style={{margin: '0.8em 0 0.4em'}} {...props} />,
        h4: ({node, ...props}) => <h4 style={{margin: '0.7em 0 0.3em'}} {...props} />,
        h5: ({node, ...props}) => <h5 style={{margin: '0.6em 0 0.2em'}} {...props} />,
        h6: ({node, ...props}) => <h6 style={{margin: '0.5em 0 0.2em'}} {...props} />,
      }}
      {...props}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MessageFormatter;
